import type { Firestore, DocumentSnapshot } from "firebase-admin/firestore";
import { USER_COLLECTION } from "../../constants";
import { sanitizePhoneNumber } from "./user-validation";

/**
 * Find a User document by email or phone number
 */
export async function findUserByEmailOrPhone(
  adminDb: Firestore,
  email?: string,
  phoneNumber?: string,
): Promise<DocumentSnapshot | null> {
  if (email) {
    const usersSnapshot = await adminDb.collection(USER_COLLECTION).get();
    for (const doc of usersSnapshot.docs) {
      const userData = doc.data();
      const emailAddresses = userData.emailAddresses || [];
      if (emailAddresses.includes(email)) {
        return doc;
      }
    }
  }

  if (phoneNumber) {
    const normalizedPhone = sanitizePhoneNumber(phoneNumber);
    const usersSnapshot = await adminDb.collection(USER_COLLECTION).get();
    for (const doc of usersSnapshot.docs) {
      const userData = doc.data();
      const phoneNumbers = userData.phoneNumbers || [];
      for (const phone of phoneNumbers) {
        const normalized = sanitizePhoneNumber(phone);
        if (normalized === normalizedPhone) {
          return doc;
        }
      }
    }
  }

  return null;
}

